import gql from 'graphql-tag'

export const DELETE_WISHLIST = gql`
  mutation($id: String!) {
    delete_marketplace_user_wishlists(where: {item_id: {_eq: $id}}) {
      affected_rows
    }
  }
`
